var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "tree-wrapper" }, [
      _c("div", { staticClass: "tree-box" }, [
        _c(
          "div",
          { staticClass: "tree-con" },
          [
            _c("span", { staticClass: "text" }, [_vm._v("菜单权限")]),
            _vm._v(" "),
            _c("el-tree", {
              ref: "tree",
              staticClass: "blue-theme",
              attrs: {
                data: _vm.treeData,
                "show-checkbox": "",
                "node-key": "value",
                "default-expand-all": true,
                "default-checked-keys": _vm.defaultCheckedKeys,
                "highlight-current": true,
                "check-on-click-node": false,
                props: _vm.defaultProps,
                "expand-on-click-node": false,
              },
              on: { check: _vm.handelCheck, "node-click": _vm.handelClick },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "check-box" }, [
          _c("div", { staticClass: "check_list" }, [
            _c("span", { staticClass: "text" }, [_vm._v(" 按钮/接口权限")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list" },
              [
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.checkValue,
                      callback: function ($$v) {
                        _vm.checkValue = $$v
                      },
                      expression: "checkValue",
                    },
                  },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      _vm._l(_vm.checkList, function (item, index) {
                        return _c(
                          "el-col",
                          { key: index, attrs: { lg: 24, xl: 8 } },
                          [
                            _c(
                              "el-checkbox",
                              {
                                staticClass: "check-item",
                                attrs: {
                                  label: item.value,
                                  disabled: _vm.isAdmin,
                                  checked: item.is_default,
                                },
                                on: {
                                  change: function (checked) {
                                    return _vm.handelCheckChange(checked, item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(item.label) +
                                    "\n                  "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }